import { render } from "./Entities.vue?vue&type=template&id=04ec3f4c&scoped=true&lang=pug"
import script from "./Entities.js?vue&type=script&lang=js&external"
export * from "./Entities.js?vue&type=script&lang=js&external"

import "./Entities.vue?vue&type=style&index=0&id=04ec3f4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ec3f4c"]])

export default __exports__